import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '../button';

const Popup = ({ open, message, subMessage, onCancel, onConfirm, confirmText }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    // 메시지를 줄바꿈으로 분리하여 렌더링
    const renderMessage = (text) => {
        if (!text) return null;
        return text.split('\n').map((line, index) => (
            <p key={index} style={{ margin: 0 }}>
                {line || '\u00A0'}
            </p>
        ));
    };

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="popup-title"
            aria-describedby="popup-description"
            sx={{
                '& .MuiDialog-paper': {
                    margin: 0,
                },
                '& .MuiBackdrop-root': {
                    backgroundColor: theme.palette.figma.white[80],
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    background: theme.palette.figma.popupBG,
                    display: 'flex',
                    width: '340px',
                    padding: '40px 20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '40px',
                },
            }}
        >
            <DialogContent
                sx={{
                    display: 'flex',
                    padding: 0,
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'stretch',
                    minHeight: 0,
                }}
            >
                <Typography
                    component="div"
                    id="popup-title"
                    sx={{
                        alignSelf: 'stretch',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                        letterSpacing: '-0.48px',
                        textAlign: 'center',
                    }}
                >
                    {renderMessage(message)}
                    {subMessage && renderMessage(subMessage)}
                </Typography>
            </DialogContent>
            <DialogActions
                disableSpacing
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                    p: 0,
                    gap: '10px',
                }}
            >
                {onCancel && (
                    <Button
                        variant="gray"
                        onClick={onCancel}
                        sx={{
                            flex: '1 0 0',
                            borderRadius: '20px',
                            height: '60px',
                            fontSize: '20px',
                            fontWeight: 500,
                            letterSpacing: '-0.6px',
                        }}
                    >
                        {t('cancel') || '취소'}
                    </Button>
                )}
                <Button
                    variant="normal"
                    onClick={onConfirm}
                    sx={{
                        flex: '1 0 0',
                        borderRadius: '20px',
                        height: '60px',
                        fontSize: '20px',
                        fontWeight: 500,
                        letterSpacing: '-0.6px',
                    }}
                >
                    {confirmText || t('confirm') || '확인'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default Popup;
